/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FilterTree
 */
export interface FilterTree {
  /**
   *
   * @type {string}
   * @memberof FilterTree
   */
  name: string;
  /**
   *
   * @type {Array<string>}
   * @memberof FilterTree
   */
  models: Array<string>;
}

/**
 * Check if a given object implements the FilterTree interface.
 */
export function instanceOfFilterTree(value: object): value is FilterTree {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('models' in value) || value['models'] === undefined) return false;
  return true;
}

export function FilterTreeFromJSON(json: any): FilterTree {
  return FilterTreeFromJSONTyped(json, false);
}

export function FilterTreeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterTree {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    models: json['models'],
  };
}

export function FilterTreeToJSON(value?: FilterTree | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    models: value['models'],
  };
}
